import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';

const TOTAL_ROWS = [
  ['on_hand', 'On hand'], ['reserved', 'Reserved'], ['available', 'Available'],
  ['allocated', 'Allocated'], ['quarantined', 'Quarantined'], ['valuation', 'Value ($)'], ['stock_rows', 'Stock rows'],
];

export const TotalsTable = ({ before, after }) => (
  <Table data-testid="reset-totals-table">
    <TableHeader>
      <TableRow><TableHead>Total</TableHead><TableHead className="text-right">Before</TableHead><TableHead className="text-right">After</TableHead></TableRow>
    </TableHeader>
    <TableBody>
      {TOTAL_ROWS.map(([k, label]) => (
        <TableRow key={k} data-testid={`reset-total-${k}`}>
          <TableCell>{label}</TableCell>
          <TableCell className="text-right font-mono" data-testid={`reset-total-${k}-before`}>{before?.[k]?.toLocaleString()}</TableCell>
          <TableCell className={`text-right font-mono ${before?.[k] !== after?.[k] ? 'font-semibold text-amber-600' : ''}`}
            data-testid={`reset-total-${k}-after`}>{after?.[k]?.toLocaleString()}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export const StockRowsTable = ({ rows }) => (
  <div className="max-h-80 overflow-auto rounded border" data-testid="reset-stock-rows">
    <Table>
      <TableHeader>
        <TableRow>
          {['Warehouse', 'SKU', 'Item', 'MPN', 'Type', 'On hand', 'Reserved', 'Allocated', 'Quar.', 'Avail. before', 'Avail. after']
            .map((h) => <TableHead key={h}>{h}</TableHead>)}
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((r) => (
          <TableRow key={r.warehouse_inventory_id} data-testid={`reset-stock-row-${r.warehouse_inventory_id}`}>
            <TableCell>{r.warehouse}</TableCell><TableCell className="font-mono">{r.sku}</TableCell><TableCell>{r.item}</TableCell>
            <TableCell>{r.mpn}</TableCell><TableCell>{r.ownership_type}</TableCell><TableCell>{r.on_hand}</TableCell>
            <TableCell className="font-semibold">{r.reserved} → 0</TableCell><TableCell>{r.allocated}</TableCell>
            <TableCell>{r.quarantined}</TableCell><TableCell>{r.available_before}</TableCell><TableCell>{r.available_after}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

export const RequestLinesTable = ({ lines }) => (
  <div className="max-h-80 overflow-auto rounded border" data-testid="reset-request-lines">
    <Table>
      <TableHeader>
        <TableRow>
          {['Job', 'Status', 'Item', 'Requested', 'Fulfilled', 'Tracking now', 'Holds (legacy)', 'After']
            .map((h) => <TableHead key={h}>{h}</TableHead>)}
        </TableRow>
      </TableHeader>
      <TableBody>
        {lines.map((l) => (
          <TableRow key={l.part_request_item_id} data-testid={`reset-line-${l.part_request_item_id}`}>
            <TableCell>{l.job_number}{l.job_name ? ` · ${l.job_name}` : ''}</TableCell><TableCell>{l.status}</TableCell>
            <TableCell>{l.item_name}</TableCell><TableCell>{l.quantity_requested}</TableCell><TableCell>{l.quantity_fulfilled}</TableCell>
            <TableCell>{l.tracking_value ?? 'empty'}</TableCell><TableCell>{l.legacy_held}</TableCell><TableCell>0</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

export const ChecksList = ({ checks, prefix = 'reset' }) => (
  <ul className="space-y-1" data-testid={`${prefix}-checks`}>
    {checks.map((c, i) => (
      <li key={c.check} className="flex items-center justify-between rounded border px-3 py-2 text-sm" data-testid={`${prefix}-check-${i}`}>
        <span>{c.check}</span>
        <span className={c.passed ? 'font-semibold text-emerald-600' : 'font-semibold text-red-600'} data-testid={`${prefix}-check-${i}-status`}>
          {c.passed ? 'PASS' : `FAIL (expected ${c.expected}, got ${c.actual})`}
        </span>
      </li>
    ))}
  </ul>
);
